// extracted by mini-css-extract-plugin
module.exports = {"Page":"DiscoveryLocation_Page__2C3Zj"};